export const credits = [
  {
    type: "Full Plan - Complete On Page SEO AI Tool",
    pricing: "$24/month",
    keywordSpyCredits: 25,
    keywordDiscoveryCredits: 60,
    keywordDifficultyCredits: 5000,
  },
  {
    type: "Full Plan - Complete On Page SEO AI Tool",
    pricing: "$54/month",
    keywordSpyCredits: 50,
    keywordDiscoveryCredits: 125,
    keywordDifficultyCredits: 10000,
  },
  {
    type: "Full Plan - Complete On Page SEO AI Tool",
    pricing: "$74/month",
    keywordSpyCredits: 75,
    keywordDiscoveryCredits: 150,
    keywordDifficultyCredits: 15000,
  },
  {
    type: "Full Plan - Complete On Page SEO AI Tool",
    pricing: "$144/month",
    keywordSpyCredits: 500,
    keywordDiscoveryCredits: 250,
    keywordDifficultyCredits: 20000,
  },
  {
    type: "Full Plan - Complete On Page SEO AI Tool",
    pricing: "$194/month",
    keywordSpyCredits: 750,
    keywordDiscoveryCredits: 1250,
    keywordDifficultyCredits: 100000,
  },
  {
    type: "Full Plan - Complete On Page SEO AI Tool",
    pricing: "$274/month",
    keywordSpyCredits: 1000,
    keywordDiscoveryCredits: 1250,
    keywordDifficultyCredits: 100000,
  },
  {
    type: "Full Plan - Complete On Page SEO AI Tool",
    pricing: "$424/month",
    keywordSpyCredits: 1500,
    keywordDiscoveryCredits: 1250,
    keywordDifficultyCredits: 100000,
  },
  {
    type: "Full Plan - Complete On Page SEO AI Tool",
    pricing: "$674/month",
    keywordSpyCredits: 2000,
    keywordDiscoveryCredits: 1250,
    keywordDifficultyCredits: 100000,
  },
  {
    type: "Full Plan - Complete On Page SEO AI Tool",
    pricing: "$874/month",
    keywordSpyCredits: 4000,
    keywordDiscoveryCredits: 1250,
    keywordDifficultyCredits: 100000,
  },
  {
    type: "Keyword Discovery - Niche Research Tool",
    pricing: "$14/month",
    keywordSpyCredits: 0,
    keywordDiscoveryCredits: 125,
    keywordDifficultyCredits: 10000,
  },
  {
    type: "Keyword Discovery - Niche Research Tool",
    pricing: "$34/month",
    keywordSpyCredits: 0,
    keywordDiscoveryCredits: 300,
    keywordDifficultyCredits: 25000,
  },
  {
    type: "Keyword Discovery - Niche Research Tool",
    pricing: "$44/month",
    keywordSpyCredits: 0,
    keywordDiscoveryCredits: 600,
    keywordDifficultyCredits: 50000,
  },
]